import api from "@/core/services/api.service";

class athleteError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const athleteService = {

    async search(params){
        try {
            api.setHeader();
            const response = await api.post("api/search/athlete", params);
            return response;
        } catch (error) {
            throw new athleteError(error.response.status, error.response)
        }
    },

    async currentPhoto(params){
        try {
            api.setHeader();
            const response = await api.post("api/photo", params);
            return response;
        } catch (error) {
            throw new athleteError(error.response.status, error.response)
        }
    }

    /*async register(params) {
        try {
            api.setHeader();
            const response = await api.post("acr/athlete/save", params)
            this.$store.dispatch(ACREDITATION, response.data);
            return response;
        } catch (error) {
            throw new athleteError(error.response.status, error.response)
        }
    },*/

}

export default athleteService
export { athleteService, athleteError }